import styled, { css } from 'styled-components';

import Image from 'next/image';
import Button from 'Elements/Button';

export const Container = styled.div<{ $isHovering: boolean }>`
    ${({ theme, $isHovering }) => css`
        background-color: #197a6e;
        border: 0.0625rem solid ${theme.colors.accents[7].hex};
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        border-radius: 0.5rem;
        height: auto;
        position: relative;
        overflow: hidden;

        @media ${theme.breakpoints.medium.media} {
            height: 100%;
            padding: 1rem;
            justify-content: space-between;
            border: none;
            background-color: ${theme.colors.accents[7].hex};
        }

        @media ${theme.breakpoints.large.media} {
            ${$isHovering &&
            css`
                background-color: ${theme.colors.accents[17].hex};
            `}
        }
    `}
`;

export const StyledImage = styled(Image)<{ $isHovering: boolean }>`
    ${({ theme, $isHovering }) => css`
        display: none;

        @media ${theme.breakpoints.medium.media} {
            display: block;
            position: relative;
            mask-image: linear-gradient(
                to bottom,
                ${theme.colors.secondary.hex}00 0%,
                ${theme.colors.secondary.hex}a6 25%,
                ${theme.colors.secondary.hex}a6 50%,
                ${theme.colors.secondary.hex}
            );
            height: 4.625rem;
            width: auto;
            margin-bottom: 0.75rem;
        }

        @media ${theme.breakpoints.large.media} {
            height: 5.25rem;
            transform: ${$isHovering ? 'translateX(15%)' : 'translateX(0)'};
            transition: transform 0.3s ease-in-out;
        }
    `}
`;

export const Heading = styled.h3`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.medium.media} {
            display: block;
            font-size: 1.5rem;
            color: ${theme.colors.secondary.hex};
            text-align: center;
            font-weight: lighter;
            font-family: ${theme.fonts.secondary};
            margin: 0;
            line-height: 1.1;
            z-index: 2;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 2rem;
        }
    `}
`;

export const StyledButton = styled(Button)`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.medium.media} {
            display: inline-flex;
            font-weight: 500;

            :hover {
                border-radius: 2rem;
            }
        }
    `}
`;

export const PhoneButton = styled.button`
    ${({ theme }) => css`
        height: 100%;
        width: 100%;
        border-radius: 0.5rem;
        padding: 0;
        border: none;
        background: none;
        color: ${theme.colors.secondary.hex};
        font-size: 1.25rem;
        padding: 0.75rem;
        font-weight: 200;
        font-family: ${theme.fonts.secondary};

        @media ${theme.breakpoints.medium.media} {
            display: none;
        }
    `}
`;
